<div class="toast-card">
  <div class="toast-head">
    <div class="head-left">
      <mat-icon class="icon">notifications</mat-icon>
      <span class="time" *ngIf="timeLabelKey; else absoluteDateTime">{{ timeLabelKey | loc }}</span>
      <ng-template #absoluteDateTime>
        <span class="time">{{ formattedDateTime }}</span>
      </ng-template>
      <span class="estate" *ngIf="data.estateName">{{ data.estateName }}</span>
    </div>

    <button mat-icon-button class="close-btn" type="button" aria-label="close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="title">{{ data.title }}</div>
  <div class="body">{{ data.body }}</div>

  <div class="actions">
    <button mat-stroked-button type="button" class="details-btn" (click)="openDetails()">{{ 'browserNtf.toast.details' | loc }}</button>
    <div class="logo_small" aria-hidden="true">
      <img src="/assets/fliko_small.svg" alt="" />
    </div>
  </div>
</div>
